var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3179 30.6219C23.6021 30.6219 30.3179 23.9062 30.3179 15.6219C30.3179 7.33768 23.6021 0.621948 15.3179 0.621948C7.0336 0.621948 0.317871 7.33768 0.317871 15.6219C0.317871 23.9062 7.0336 30.6219 15.3179 30.6219Z",
    fill: "#F4F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.063 9.04395H20.573C20.8931 9.04395 21.2001 9.17111 21.4264 9.39747C21.6528 9.62382 21.78 9.93083 21.78 10.2509V19.6599H8.85596V10.2509C8.85596 9.93083 8.98312 9.62382 9.20948 9.39747C9.43584 9.17111 9.74284 9.04395 10.063 9.04395Z",
    stroke: "#464646",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5842 17.4259H15.4752C15.5712 17.4259 15.6633 17.464 15.7311 17.5319C15.799 17.5998 15.8372 17.6919 15.8372 17.7879V19.6609H11.2222V17.7879C11.2222 17.6919 11.2603 17.5998 11.3282 17.5319C11.3961 17.464 11.4882 17.4259 11.5842 17.4259Z",
    fill: "#EB008B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6831 11.814H17.8111",
    stroke: "#464646",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6831 13.8579H15.3181",
    stroke: "#464646",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6839 19.6609H7.95094C7.74935 19.6609 7.58594 19.8243 7.58594 20.0259V21.8349C7.58594 22.0365 7.74935 22.1999 7.95094 22.1999H22.6839C22.8855 22.1999 23.0489 22.0365 23.0489 21.8349V20.0259C23.0489 19.8243 22.8855 19.6609 22.6839 19.6609Z",
    stroke: "#464646",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTask);
export default __webpack_public_path__ + "static/media/icon-task.a55bc001671273ec05ad9835f2a3f816.svg";
export { ForwardRef as ReactComponent };